var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWithoutBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.21934 1.21995C0.359966 1.0795 0.550589 1.00061 0.74934 1.00061C0.948091 1.00061 1.13871 1.0795 1.27934 1.21995L5.52934 5.46995C5.66979 5.61058 5.74868 5.8012 5.74868 5.99995C5.74868 6.1987 5.66979 6.38932 5.52934 6.52995L1.27934 10.78C1.13716 10.9124 0.949119 10.9846 0.754818 10.9811C0.560517 10.9777 0.375132 10.899 0.237719 10.7616C0.100306 10.6242 0.0215929 10.4388 0.0181646 10.2445C0.0147364 10.0502 0.0868603 9.86213 0.21934 9.71995L3.93934 5.99995L0.21934 2.27995C0.0788899 2.13933 0 1.9487 0 1.74995C0 1.5512 0.0788899 1.36058 0.21934 1.21995Z",
    fill: "#525355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWithoutBar);
export default __webpack_public_path__ + "static/media/rightArrowWithoutBar.a536f2019d0267c72c4d9863684cd370.svg";
export { ForwardRef as ReactComponent };